import React from 'react';
import services from '../Assets/Data/features.json';
import { FaCheckCircle } from 'react-icons/fa';
import { BsPalette, BsBoxSeam, BsGlobe2, BsPersonBadge } from 'react-icons/bs';
import map from '../Assets/images/map.png';
import event from '../Assets/Data/event.json'; 
const images = require.context('../Assets/images', false, /\.(png|jpe?g|svg)$/);



// Map string names from JSON to actual icon components
const iconMap = {
    palette: <BsPalette size={30} color="#4B5563" />,
    box: <BsBoxSeam size={30} color="#4B5563" />,
    globe: <BsGlobe2 size={30} color="#4B5563" />,
    user: <BsPersonBadge size={30} color="#4B5563" />
  };
  
  

const Feature = () => {
  return (
    <div>
<div className='features'>
<div className=' text-center'>

    <h1 className='text-xxl green-text m- mb-2'>We Do More Than Just Customizing <br></br>Merch.</h1>
    <p className="text-xl white-text m-0 mb-5">From design to delivery, we handle every aspect of your merchandise needs with professional expertise <br></br>and attention to detail.</p>
  
</div>
<div className="grid-container">
      {services.map((service, index) => (
        <div key={index} className="card">
          <div className="card-header">
            <div className="card-icon">
              {iconMap[service.icon] || <BsPalette size={24} />} {/* Fallback icon */}
            </div>
            <div>
              <h3 className="card-title">{service.title}</h3>
              <p className="card-subtitle">{service.subtitle}</p>
            </div>
          </div>
          <ul className="card-list">
            {service.features.map((feature, i) => (
              <li key={i}>
                <FaCheckCircle /> {feature}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
</div>
 <div className='world-map-wrapper d-flex align-center mt-5'>
    <div>  
    <div className='event-wrapper'>
    <div className='product-names'>
    <div className="marquee-container">
    <div className="shadow-top"></div>
    <div className="shadow-bottom"></div>
      <div className="marquee">
        <div className="marquee-track">
       
        {event.map((item, index) => (
  <img key={index} src={images(`./${item.id}`)} alt={`item-${index}`} />
))}
{event.map((item, index) => (
  <img key={index} src={images(`./${item.id}`)} alt={`item-${index}`} />
))}
        </div>
      </div>
    </div>
    </div>
    </div></div>
 
    <div className='map-container' >
        <img src={map} alt='map'></img>
        <div className='abs-text'>
    <h1 className='green-text text-xxl'>We deliver everywhere the chain goes.</h1>
<p className='white-text text-xl'>From Denver to Seoul, from EthIndia to Token2049. We've shipped merch to major crypto hubs and events worldwide.</p>
        </div>
    </div>
 </div>
</div>
    
  );
};




export default Feature;
